import { MINUTE_MS, SECOND_MS } from '../../time';
export var dealsSliceName = 'deals';
export var DEALS_MIN_UPDATE = 5 * MINUTE_MS;
export var DEALS_FETCH_TIMEOUT = 30 * SECOND_MS;
